import(/* webpackMode: "eager" */ "/vercel/path0/src/app/industries/professional-services/page.tsx");
